import { render } from "./TeacherView.vue?vue&type=template&id=46c2a43a"
import script from "./TeacherView.vue?vue&type=script&lang=js"
export * from "./TeacherView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__